<template>
	<van-nav-bar title="群收款"  />

	<div class="page-content">
		<!-- 搜索区域 -->
		<van-search
			v-model="searchForm.keyword"
			placeholder="搜索工种名称"
			show-action
			@search="handleSearch"
			@cancel="handleReset"
		/>

		<!-- 状态筛选：全部/支付中/已取消 -->
		<van-tabs v-model:active="searchForm.status" @change="handleSearch" sticky>
			<van-tab title="全部" name="" />
			<van-tab title="支付中" name="paying" />
			<van-tab title="已取消" name="cancelled" />
		</van-tabs>

		<!-- 收款列表 -->
		<van-list
			v-model:loading="loading"
			:finished="finished"
			finished-text="没有更多了"
			@load="getData"
			class="collection-list"
		>
			<van-cell
				v-for="item in tableData"
				:key="item.id"
				class="collection-item"
				is-link
				@click="handleView(item)"
			>
				<template #title>
					<div class="item-header">
						<span class="item-name">{{ item.name }}</span>
						<van-tag :type="getStatusType(item.status)" size="medium">
							{{ getStatusText(item.status) }}
						</van-tag>
					</div>
				</template>
				<template #label>
					<div class="item-info">
						<div class="item-row">
							<span>收款金额：</span>
							<span class="item-amount">¥{{ item.amount }}</span>
						</div>
						<div class="item-row">
							<span>子订单创建数：</span>
							<span>{{ item.child_order_count || 0 }}</span>
						</div>
						<div class="item-row">
							<span>子订单支付数：</span>
							<span>{{ item.child_paid_count || 0 }}</span>
						</div>
						<div class="item-row">
							<span>创建人：</span>
							<span>{{ item.creator }}</span>
						</div>
						<div class="item-row">
							<span>创建时间：</span>
							<span>{{ item.create_time }}</span>
						</div>
					</div>
					<div class="item-actions" @click.stop>
						<van-button
							size="small"
							type="primary"
							plain
							hairline
							@click="handleViewSubOrders(item)"
							style="margin-right: 8px;"
						>
							查看子订单
						</van-button>
						<van-button
							v-if="item.status === 1"
							size="small"
							type="warning"
							plain
							hairline
							@click="handleSendMiniProgram(item)"
							style="margin-right: 8px;"
						>
							发送小程序
						</van-button>
						<van-button
							v-if="item.status === 1"
							size="small"
							type="danger"
							plain
							hairline
							@click="handleCancel(item)"
						>
							手动取消
						</van-button>
					</div>
				</template>
			</van-cell>
		</van-list>

		<!-- 创建按钮 -->
		<div class="create-btn-wrap">
			<van-button round block type="primary" class="create-btn" @click="handleCreate">创建群收款</van-button>
		</div>
	</div>

	<!-- 子订单列表弹窗 -->
	<van-popup v-model:show="subOrderVisible" position="bottom" round :style="{ height: 'auto', maxHeight: '90%', width: 'calc(100% - 32px)', maxWidth: '440px', left: '50%', transform: 'translateX(-50%)' }">
			<div class="popup-content">
			<div class="form-popup-header">
				<span class="cancel-btn" @click="subOrderVisible = false">取消</span>
				<span class="title">子订单列表</span>
				<span class="placeholder"></span>
			</div>
			<div class="sub-order-list" v-if="subOrderList.length > 0">
				<div
					v-for="sub in subOrderList"
					:key="sub.id"
					class="sub-order-item"
				>
					<div class="sub-order-row">
						<span class="sub-label">子订单号</span>
						<span class="sub-value">{{ sub.order_no }}</span>
					</div>
					<div class="sub-order-row">
						<span class="sub-label">姓名</span>
						<span class="sub-value">{{ sub.name || '未填写' }}</span>
					</div>
					<div class="sub-order-row">
						<span class="sub-label">手机号</span>
						<span class="sub-value">{{ sub.phone || '未填写' }}</span>
					</div>
					<div class="sub-order-row">
						<span class="sub-label">支付状态</span>
						<van-tag :type="sub.pay_status === 'paid' ? 'success' : 'warning'" size="small">
							{{ sub.pay_status === 'paid' ? '已支付' : '未支付' }}
						</van-tag>
					</div>
				</div>
			</div>
			<div v-else class="empty-tip">
				暂无子订单
			</div>
		</div>
	</van-popup>

	<!-- 创建/编辑弹窗 -->
	<van-popup v-model:show="formVisible" position="bottom" round :close-on-click-overlay="false" :style="{ height: 'auto', maxHeight: '90%', width: 'calc(100% - 32px)', maxWidth: '440px', left: '50%', transform: 'translateX(-50%)' }">
		<div class="popup-content">
			<div class="form-popup-header">
				<span class="cancel-btn" @click="formVisible = false">取消</span>
				<span class="title">{{ isEdit ? '编辑收款' : '创建群收款' }}</span>
				<span class="placeholder"></span>
			</div>
			<van-cell-group inset style="margin-top:0">
				<!-- 业务类型 -->
				<van-field label="业务类型">
					<template #input>
						<select v-model="formData.bussines1" class="pc-select no-arrow" @change="onBusinessChange">
							<option value="">请选择业务类型</option>
							<option v-for="item in columns_data1" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 专业/工种 -->
				<van-field label="专业/工种">
					<template #input>
						<select v-model="formData.bussines2" class="pc-select no-arrow" @change="onGongChange">
							<option value="">请选择专业/工种</option>
							<option v-for="item in columns_data8" :key="item.value" :value="item.text">
								{{ item.text }}
							</option>
						</select>
					</template>
				</van-field>

				<!-- 类型选择 -->
				<van-field class="lh-40" name="radio" v-show="show_it3">
					<template #label>
						<span class="label-text">类型</span>
					</template>
					<template #input>
						<van-radio-group v-model="formData.bussines3_id" direction="horizontal" @change="chossed_value">
							<van-radio v-for="option in radioOptions" :key="option.label" :name="option.id">
								{{ option.label }}
							</van-radio>
						</van-radio-group>
					</template>
				</van-field>

				<!-- 订单金额 -->
				<van-field class="lh-40" name="price" label="订单金额" :error="!!errorMsg" :error-message="errorMsg">
					<template #input>
						<input
							v-model="formData.price"
							placeholder="订单金额"
							class="price_input"
							:class="['custom-input', { 'custom-input-error': errorMsg }]"
							@input="validatePrice"
							@blur="validatePrice"
						/>
					</template>
				</van-field>

				<!-- 收款单位 -->
				<van-field class="lh-40" name="radio" label="收款单位">
					<template #input>
						<van-radio-group v-model="formData.componey" direction="horizontal">
							<van-radio name="1">筑信学校</van-radio>
							<van-radio name="2" icon-size="18px">筑信企业</van-radio>
						</van-radio-group>
					</template>
				</van-field>

				<!-- 告知书 -->
				<van-field class="lh-40" name="radio" label="告知书">
					<template #input>
						<van-radio-group v-model="formData.is_sign" direction="horizontal">
							<van-radio name="1">要签订</van-radio>
							<van-radio name="0">不签订</van-radio>
						</van-radio-group>
					</template>
				</van-field>
			</van-cell-group>

			<div class="submit-btn">
				<van-button round block type="primary" @click="handleSubmit" :loading="submitLoading">
					{{ isEdit ? '保存修改' : '创建收款' }}
				</van-button>
			</div>
		</div>
	</van-popup>
</template>

<script>
	import '@vant/touch-emulator';
	import {
		NavBar,
		Search,
		Tabs,
		Tab,
		List,
		Cell,
		Tag,
		Button,
		Popup,
		CellGroup,
		Field,
		Radio,
		RadioGroup,
		showToast,
		showLoadingToast,
		closeToast,
		showDialog,
		Picker
	} from 'vant';
	import axios from 'axios';
	import sha1 from 'js-sha1';
	import * as ww from '@wecom/jssdk';
	

	export default {
		data() {
			return {
				searchForm: {
					keyword: '',
					status: ''
				},
				tableData: [],
				loading: false,
				finished: true,
				formVisible: false,
				isEdit: false,
				submitLoading: false,
				currentRow: null,
				errorMsg: '',

				// 子订单相关
				subOrderVisible: false,
				subOrderList: [],
				// 表单数据
				formData: {
					bussines1: '',
					bussines2: '',
					bussines3_id: '',
					bussines_type: '无',
					price: '',
					componey: '1',
					is_sign: '1'
				},

				// 业务类型数据
				columns_data1: [],
				columns_data8: [],
				radioOptions: [],
				show_it3: false,
				checked_value: {},
			};
		},

		async mounted() {
			this.getBussinesList();
			this.getData();
			
			// ========== 新增调试日志 ==========
			console.log('=== 附件栏调试开始 ===');
			console.log('当前页面URL:', window.location.href);
			console.log('企业微信JS-SDK对象:', typeof ww, ww);
			
			// 检查是否在 iframe 中
			const isInIframe = window.self !== window.top;
			console.log('是否在iframe中:', isInIframe);
			if (isInIframe) {
				try {
					console.log('父窗口origin:', document.referrer);
				} catch(e) {
					console.log('无法获取父窗口信息');
				}
			}
			
			// 初始化企业微信配置
			await this.initWxConfig();
		},

		methods: {
			async initWxConfig() {
				try {
					console.log('开始注册企业微信SDK...');
					ww.register({
						corpId: 'wwc76de3cd7c5ce1be',
						agentId: 1000113,
						// 注意：添加了 'getContext' 接口
						jsApiList: ['sendChatMessage', 'hideChatAttachmentMenu', 'getContext'],

						async getAgentConfigSignature() {
							try {
								console.log('正在获取agent signature...');
								const res = await axios.get('https://ddz.zhuxinedu.com/api/index/get_agent_signature');
								const agent_ticket = res.data;
								console.log('获取到agent_ticket:', agent_ticket ? '有值' : '空');

								const noncestr = Math.random().toString(36).slice(2, 8);
								const timestamp = Math.floor(Date.now() / 1000);
								const this_url = window.location.href.split('#')[0];
								console.log('签名URL:', this_url);
								
								const str = `jsapi_ticket=${agent_ticket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${this_url}`;
								const signature = sha1(str);
								
								console.log('签名参数: timestamp=' + timestamp + ', nonceStr=' + noncestr);
								return {
									timestamp,
									nonceStr: noncestr,
									signature
								};
							} catch (err) {
								console.error('获取签名失败', err);
								throw err;
							}
						},

						onAgentConfigSuccess: () => {
							console.log('✅ 企业微信SDK配置成功');
							// 配置成功后检查上下文并隐藏底部按钮
							this.checkContextAndHideButton();
						},
						onAgentConfigFail: (err) => {
							console.error('❌ 企业微信SDK配置失败', err);
						}
					});
				} catch (e) {
					console.error('初始化企业微信SDK失败', e);
				}
			},

			// 新增：检查入口上下文，然后尝试隐藏按钮
			async checkContextAndHideButton() {
				console.log('开始检查入口上下文...');
				try {
					// 调用 getContext 获取当前入口类型
					const contextRes = await new Promise((resolve, reject) => {
						ww.getContext({
							success: (res) => {
								console.log('✅ getContext 成功:', res);
								resolve(res);
							},
							fail: (err) => {
								console.error('❌ getContext 失败:', err);
								reject(err);
							}
						});
					});
					
					const entry = contextRes.entry;
					console.log('当前入口类型 entry:', entry);
					
					if (entry === 'chat_attachment') {
						console.log('✓ 当前处于聊天附件栏，可以隐藏发送按钮');
						this.tryHideAttachmentBar();
					} else if (entry === 'single_chat_tools') {
						console.log('⚠️ 当前入口为单聊工具栏，可能不支持隐藏发送按钮');
						this.tryHideAttachmentBar(); // 仍尝试调用
					} else {
						console.warn('⚠️ 当前入口不是聊天附件栏，隐藏发送按钮可能无效。entry =', entry);
						// 仍然尝试调用，但预期会失败
						this.tryHideAttachmentBar();
					}
				} catch (err) {
					console.error('获取上下文失败，仍尝试隐藏按钮', err);
					this.tryHideAttachmentBar();
				}
			},

			async tryHideAttachmentBar() {
				console.log('尝试调用 hideChatAttachmentMenu ...');
				try {
					// 关键修正：必须传入 menuList 参数，值为 ["sendMessage"]
					const invokeRes = await new Promise((resolve, reject) => {
						ww.invoke('hideChatAttachmentMenu', { menuList: ["sendMessage"] }, (res) => {
							console.log('hideChatAttachmentMenu 回调结果:', res);
							if (res.err_msg === 'hideChatAttachmentMenu:ok') {
								resolve(res);
							} else {
								reject(res);
							}
						});
					});
					console.log('✅ 隐藏按钮成功:', invokeRes);
				} catch (err) {
					console.error('❌ 隐藏按钮失败:', err);
					// 如果失败，输出详细错误信息
					if (err && err.err_msg) {
						console.error('错误码/信息:', err.err_msg);
					}
				}
			},

			validatePrice() {
				const val = String(this.formData.price ?? '').trim();
				if (val === '') {
					this.errorMsg = '请输入订单金额';
					return false;
				}
				const num = Number(val);
				if (isNaN(num) || num <= 0) {
					this.errorMsg = '请输入正确内容';
					return false;
				}
				this.errorMsg = '';
				return true;
			},

			getStatusText(status) {
				const map = {
					1: '支付中',
					0: '已取消',
				};
				return map[status] || status;
			},

			getStatusType(status) {
				const map = {
					1: 'warning',
					0: 'default',
				};
				return map[status] || 'default';
			},

			handleSearch() {
				this.getData();
			},

			handleReset() {
				this.searchForm.keyword = '';
				this.searchForm.status = '';
				this.getData();
			},

			getData() {
				this.loading = true;
				axios.post('https://ddz.zhuxinedu.com/api/company/get_order_list', {
					ww_user_id: localStorage.getItem('ww_user_id'),
					keyword: this.searchForm.keyword,
					status: this.searchForm.status
				}).then(res => {
					this.tableData = res.data.map(item => ({
						id: item.id,
						name: item.bussines_type +'-'+ item.subject +'-'+ (item.type || ''),
						amount: item.price,
						status: item.status,
						creator: item.ww_user_name,
						create_time: item.create_time,
						child_order_count: item.child_order_count,
						child_paid_count: item.child_paid_count
					}));
					this.loading = false;
					this.finished = true;
				}).catch(err => {
					console.error('获取订单列表失败', err);
					this.loading = false;
					this.finished = true;
				});
			},

			handleView(item) {
				// 只打开详情，不显示子订单列表
				this.currentRow = item;
			},

			handleViewSubOrders(item) {
				this.currentRow = item;
				this.subOrderList = [];
				this.subOrderVisible = true;
				this.getSubOrders();
			},

			getSubOrders() {
				if (!this.currentRow) return;
				this.loading = true;
				axios.post('https://ddz.zhuxinedu.com/api/company/get_child_order_list', {
					parent_id: this.currentRow.id
				}).then(res => {
					this.subOrderList = res.data.map(item => ({
						id: item.id,
						order_no: item.order_no,
						name: item.name,
						phone: item.phone,
						pay_status: item.pay_status
					}));
					this.loading = false;
					this.finished = true;
				}).catch(err => {
					console.error('获取子订单列表失败', err);
					this.loading = false;
					this.finished = true;
				});
			},

			handleCreate() {
				this.isEdit = false;
				this.formData = {
					name: '',
					bussines1: '',
					bussines2: '',
					bussines3_id: '',
					bussines_type: '无',
					price: '',
					componey: '1',
					is_sign: '1'
				};
				this.errorMsg = '';
				this.show_it3 = false;
				this.columns_data8 = [];
				this.radioOptions = [];
				this.currentDate = '';
				this.formVisible = true;
			},
			handleCancel(item) {
				showDialog({
					title: '提示',
					message: '确定要手动取消该收款吗？'
				}).then(() => {
					axios.post('https://ddz.zhuxinedu.com/api/company/cancel_company_order', {
						order_id: item.id
					}).then(() => {
						showToast('取消成功');
						this.getData();
					}).catch(() => {
						showToast('取消失败');
					});
				}).catch(() => {});
			},
			async handleSendMiniProgram(item) {
				console.log('handleSendMiniProgram called for order:', item.id);
				
				// 构造小程序分享信息
				const order_id = item.id;
				const title = item.name + ' - 群收款';
				const imgRes = await axios.post('https://ddz.zhuxinedu.com/api/company/get_company_img', {
					text  : title,
					amount: item.amount
				});
				
				console.log(imgRes,'图片地址')
				const share_img = imgRes.data;
				
				ww.sendChatMessage({
					msgtype: 'miniprogram',
					miniprogram: {
						appid: 'wx6c29fdf36fa14e23',
						title: title,
						imgUrl: share_img,
						page: 'pages/company/company.html?order_id=' + order_id,
					},
					success: () => {
						showToast('发送成功');
					},
					fail: (err) => {
						showToast('发送失败: ' + JSON.stringify(err));
						console.error('企业微信错误详情:', err);
					}
				});
			},async getBussinesList() {
				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_bussines_choose_data', {
						field: 'yewu'
					});
					this.columns_data1 = res.data.map(item => ({
						text: item,
						value: item
					}));
				} catch (err) {
					console.error('获取业务类型失败', err);
				}
			},

			async onBusinessChange() {
				this.formData.bussines2 = '';
				this.formData.bussines3_id = '';
				this.formData.price = '';
				this.formData.bussines_type = '无';
				this.radioOptions = [];
				this.show_it3 = false;
				this.checked_value = {};

				const selected = this.columns_data1.find(item => item.text === this.formData.bussines1);
				if (!selected) return;

				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_jdy_entry_list', {
						yewu: selected.value
					});
					const list = res.data.map(item => ({
						text: item.gong,
						value: item.gong
					}));
					this.columns_data8 = [...new Map(list.map(item => [item.value, item])).values()];
				} catch (err) {
					console.error('获取专业/工种失败', err);
				}
			},

			async onGongChange() {
				this.formData.bussines3_id = '';
				this.formData.price = '';
				this.formData.bussines_type = '无';
				this.show_it3 = false;
				this.checked_value = {};

				const selected = this.columns_data8.find(item => item.text === this.formData.bussines2);
				if (!selected) return;

				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_jdy_entry_list', {
						yewu: this.formData.bussines1,
						gong: selected.value
					});
					const arr = res.data
						.map(item => ({
							id: item._id,
							label: item.type,
							value: item.price
						}))
						.filter(item => item.label !== '无');

					this.radioOptions = arr;
					this.show_it3 = arr.length > 0;
				} catch (err) {
					this.radioOptions = [];
					this.show_it3 = false;
					showToast('获取类型失败，请重新选择专业/工种');
				}
			},
			chossed_value() {
				const selected = this.radioOptions.find(item => item.id === this.formData.bussines3_id);
				if (!selected) {
					this.formData.price = '';
					this.formData.bussines_type = '无';
					this.checked_value = {};
					return;
				}
				this.formData.bussines_type = selected.label;
				this.formData.price = selected.value;
				this.checked_value = selected;
			},

			handleFormCancel() {
				this.formVisible = false;
			},

			handleSubmit() {
				if (!this.formData.bussines1 || !this.formData.bussines2) {
					showToast('请选择业务类型和专业/工种');
					return;
				}
				if (this.radioOptions.length > 0 && !this.formData.bussines3_id) {
					showToast('请选择具体类型');
					return;
				}
				if (!this.validatePrice()) {
					return;
				}

				this.submitLoading = true;
				showLoadingToast({ forbidClick: true });
				
				axios.post('https://ddz.zhuxinedu.com/api/company/sent_company_reg_info', {
					bussines_type: this.formData.bussines1,
					subject: this.formData.bussines2,
					type: this.formData.bussines_type,
					price: this.formData.price,
					componey: this.formData.componey,
					is_sign: this.formData.is_sign,
					ww_user_id: localStorage.getItem('ww_user_id'),
					ww_user_name: localStorage.getItem('ww_user_name'),
					ww_department: localStorage.getItem('ww_department')
				}).then(res => {
					console.log(res,'创建订单返回')
					closeToast();
					this.submitLoading = false;
					this.formVisible = false;
					if (res.data === 'Failed') {
						showToast('提交失败：类型不允许或参数错误');
					} else {
						showToast(this.isEdit ? '修改成功' : '创建成功');
						this.getData();
					}
				}).catch(err => {
					closeToast();
					this.submitLoading = false;
					showToast('提交失败');
					console.error('提交订单失败', err);
				});
			}
		},

		components: {
			VanNavBar: NavBar,
			VanSearch: Search,
			VanTabs: Tabs,
			VanTab: Tab,
			VanList: List,
			VanCell: Cell,
			VanTag: Tag,
			VanButton: Button,
			VanPopup: Popup,
			VanCellGroup: CellGroup,
			VanField: Field,
			VanRadio: Radio,
			VanRadioGroup: RadioGroup,
			VanPicker: Picker
		}
	};
</script>

<style scoped>
	.page-content {
		background: #fff;
		min-height: 100vh;
	}

	.collection-list {
		padding: 0 12px;
	}

	.collection-item {
		margin: 8px 0;
		border-radius: 8px;
		background: #fff;
	}

	.item-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-name {
		font-weight: 600;
		font-size: 16px;
	}

	.item-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 30px;
		padding-top: 12px;
		border-top: 1px dashed #eee;
	}

	.item-info {
		margin-top: 8px;
		font-size: 13px;
		color: #666;
	}

	.item-row {
		display: flex;
		justify-content: space-between;
		line-height: 1.8;
	}

	.item-amount {
		color: #ee0a24;
		font-weight: 600;
	}

	.create-btn-wrap {
		padding: 20px 10% 30px;
	}

	.create-btn {
		width: 100%;
	}

	.popup-content {
		padding: 16px;
		max-width: 100%;
		box-sizing: border-box;
	}

	.form-popup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px;
		border-bottom: 1px solid #eee;
	}

	.form-popup-header .cancel-btn {
		color: #969799;
		font-size: 14px;
	}

	.form-popup-header .title {
		font-size: 16px;
		font-weight: 600;
	}

	.form-popup-header .placeholder {
		width: 40px;
	}

	.popup-footer {
		padding: 16px;
	}

	.submit-btn {
		padding: 16px;
	}

	.text-primary {
		color: #1989fa;
		font-weight: 600;
	}

	.sub-order-list {
		max-height: 60vh;
		overflow-y: auto;
		margin-top: 12px;
	}

	.sub-order-item {
		background: #f7f8fa;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
	}

	.sub-order-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 1.8;
	}

	.sub-label {
		color: #969799;
		font-size: 13px;
	}

	.sub-value {
		font-size: 13px;
		color: #323233;
	}

	.empty-tip {
		text-align: center;
		color: #969799;
		padding: 40px 0;
	}

	.lh-40 {
		line-height: 40px !important;
	}

	.pc-select {
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 6px;
		font-size: 15px;
		outline: none;
		background: #fff;
	}

	.pc-select:focus {
		border-color: #1989fa;
	}

	.no-arrow {
		appearance: none;
		-webkit-appearance: none;
		background-image: none;
	}

	.price_input {
		width: 100%;
		border: solid 1px #eee;
		border-radius: 6px;
		padding: 0 10px;
	}

	.datetime-input {
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 6px;
		font-size: 15px;
		outline: none;
		background: #fff;
		box-sizing: border-box;
	}


	:deep(.van-field) {
		align-items: center !important;
	}

	:deep(.van-field__label) {
		align-self: center !important;
		width: 80px;
	}

	:deep(.van-field__control) {
		align-self: center !important;
	}

	.label-text {
		display: inline-block;
		width: 80px;
	}
</style>